// import React, { useState } from "react";
// import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
// import Login from "./components/Login.js";
// import Verification from "./components/verification.js";
// import JobsHistory from "./layouts/JobsHistory.js";
// import AssignJob from "./layouts/AssignJob.js";
// import Sidebar from "../src/components/navbar/Slidebar.js";
// import TodayAttendance from "./layouts/TodayAttendance.js";
// import AssignOT from "./layouts/AssignOT.js";
// import OTDetails from "./layouts/OTDetails.js";
// import HolidayOT from "./layouts/HolidayOT";
// import QRScanner from "./layouts/QRScanner.js";
// import { IconButton, AppBar, Toolbar, Box } from "@mui/material";
// import MenuIcon from "@mui/icons-material/Menu";
// import JobsHistoryAll from "./layouts/JobHistoryAll.js";
// import ProtectedRoute from "./components/Protectedroute.js";


// function App() {
//   const [drawerOpen, setDrawerOpen] = useState(false);

//   const sidebarPages = [
//     "/home",
//     "/todayAttendance",
//     "/jobHistory",
//     "/jobHistoryAll",
//     "/assignJob",
//     "/assignOT",
//     "/otDetails",
//     "/holidayOT"
//   ];

//   const location = useLocation();

//   const shouldRenderSidebar = sidebarPages.includes(location.pathname);

//   return (
//     <>
//       {/* Header with the hamburger menu icon */}
//       <AppBar
//         position="fixed"
//         sx={{ backgroundColor: "transparent", boxShadow: "none" }}
//       >
//         <Toolbar>
//           {shouldRenderSidebar && ( // Only render the menu icon if the sidebar should be visible
//             <IconButton
//               edge="start"
//               color="inherit"
//               onClick={() => setDrawerOpen(!drawerOpen)}
//               sx={{ mr: 2 }}
//             >
//               <MenuIcon />
//             </IconButton>
//           )}
//         </Toolbar>
//       </AppBar>

//       {/* Render Sidebar only on specified routes */}
//       {shouldRenderSidebar && (
//         <Sidebar open={drawerOpen} toggleDrawer={() => setDrawerOpen(!drawerOpen)} />
//       )}

//       <Box
//         sx={{
//           display: "flex",
//           marginTop: "64px",
//         }}
//       >
//         <Routes>
//           <Route path="/" element={<Login />} />
//           <Route path="/verify" element={<Verification />} />
//           <Route path="/home" element={<ProtectedRoute> <QRScanner /> </ProtectedRoute>} />          
//           <Route path="/jobHistory" element={<ProtectedRoute> <JobsHistory /> </ProtectedRoute>} />
//           <Route path="/jobHistoryAll" element={<ProtectedRoute> <JobsHistoryAll /> </ProtectedRoute>} />
//           <Route path="/assignJob" element={<ProtectedRoute> <AssignJob /> </ProtectedRoute>} />
//           <Route path="/todayAttendance" element={<ProtectedRoute> <TodayAttendance /> </ProtectedRoute>} />
//           <Route path="/assignOT" element={<ProtectedRoute> <AssignOT /> </ProtectedRoute>} />       
//           <Route path="/otDetails" element={<ProtectedRoute> <OTDetails /> </ProtectedRoute>} /> 
//           <Route path="/holidayOT" element={<ProtectedRoute> <HolidayOT /> </ProtectedRoute>} />     
               
//           <Route path="*" element={<Navigate to="/" />} />
//         </Routes>
//       </Box>
//     </>
//   );
// }

// export default function Root() {
//   return (
//     <Router>
//       <App />
//     </Router>
//   );
// }


import React, { useState, useEffect, useMemo } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { restoreSession } from "./actions/authActions";
import { fetchEmployeeBirthdayList } from "./actions/EventsAction";
import Login from "./components/Login.js";
import Verification from "./components/verification.js";
import JobsHistory from "./layouts/JobsHistory.js";
import AssignJob from "./layouts/AssignJob.js";
import Sidebar from "../src/components/navbar/Slidebar.js";
import TodayAttendance from "./layouts/TodayAttendance.js";
import AssignOT from "./layouts/AssignOT.js";
import OTDetails from "./layouts/OTDetails.js";
import HolidayOT from "./layouts/HolidayOT";
import QRScanner from "./layouts/QRScanner.js";
import { IconButton, AppBar, Toolbar, Box, Badge } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import JobsHistoryAll from "./layouts/JobHistoryAll.js";
import ProtectedRoute from "./components/ProtectedRoute.js";
//dulitha
import OTTableViews from "./layouts/OTViewTables.js"
import SupervisorWiseOT from "./components/tables/SupervisorWiseOT.js"
import NonAllocatedEmp from "./components/tables/NonAllocatedEmp.js"
import QRJobScanner from "./layouts/QRJobScanner.js"; 
import Production from "./layouts/Production.js";
import Employees from "./layouts/Employees.js";
import IWORequest from "./layouts/IWORequest.js";
import Events from "./layouts/Events.js";
import LeaveApproval from "./layouts/LeaveApproval.js";
import InsertFrames from "./layouts/InsertFrames.js";
import DailyRemark from "./layouts/DailyRemark.js";
import RemarkHistory from "./layouts/Remarkhistory.js";



function App() {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const dispatch = useDispatch();

  // Restore session on app initialization
  useEffect(() => {
    dispatch(restoreSession());
  }, [dispatch]);

  const sidebarPages = [
    "/home",
    "/qrJobScanner",
    "/todayAttendance",
    "/jobHistory",
    "/jobHistoryAll",
    "/assignJob",
    "/assignOT",
    "/otDetails",
    "/holidayOT",
    "/overTimeView",//dulitha
    "/production",
    "/employees",
    "/iwoRequest",
    "/events",
    "/leaveApproval",//dulitha
    "/insertFrames", //dulitha
    "/dailyRemark", //dulitha
    "/remarkHistory", //dulitha
  ];

  const location = useLocation();
  const shouldRenderSidebar = sidebarPages.includes(location.pathname);

  // Birthday-today indicator on the hamburger icon — access users only
  const EVENTS_ACCESS_IDS = ["3001230", "3000821", "3001087", "3000309", "3001413", "3001411", "3000701"];
  const EVENTS_ALLOWED_LOCATIONS = ["HAO", "ISM", "IIM"];
  const employeeId = localStorage.getItem("employeeId") || "";
  const canSeeEvents = EVENTS_ACCESS_IDS.includes(String(employeeId));

  useEffect(() => {
    if (canSeeEvents) {
      dispatch(fetchEmployeeBirthdayList());
    }
  }, [canSeeEvents, dispatch]);

  const { birthdayItems: eventsBirthdayItems } = useSelector((state) => state.events || {});

  const hasBirthdayToday = useMemo(() => {
    if (!canSeeEvents || !eventsBirthdayItems || eventsBirthdayItems.length === 0) return false;
    const today = new Date();
    const todayDay = String(today.getDate()).padStart(2, "0");
    const todayMonth = today.toLocaleString("en-US", { month: "short" }).toUpperCase();
    return eventsBirthdayItems.some((emp) => {
      if (!EVENTS_ALLOWED_LOCATIONS.includes(emp.EmployeeLocation) || emp.EmployeeStatus !== "A") return false;
      const parts = String(emp.EmployeeBirthday || "").split("-");
      return parts.length >= 2 && parts[0] === todayDay && parts[1]?.toUpperCase() === todayMonth;
    });
  }, [canSeeEvents, eventsBirthdayItems]);

  return (
    <>
      {/* Header with the hamburger menu icon */}
      <AppBar
        position="fixed"
        sx={{ backgroundColor: "transparent", boxShadow: "none" }}
      >
        <Toolbar>
          {shouldRenderSidebar && (
            <IconButton
              edge="start"
              color="inherit"
              onClick={() => setDrawerOpen(!drawerOpen)}
              sx={{ mr: 2 }}
            >
              <Badge
                color="error"
                variant="dot"
                overlap="circular"
                invisible={!hasBirthdayToday}
              >
                <MenuIcon />
              </Badge>
            </IconButton>
          )}
        </Toolbar>
      </AppBar>

      {/* Render Sidebar only on specified routes */}
      {shouldRenderSidebar && (
        <Sidebar open={drawerOpen} toggleDrawer={() => setDrawerOpen(!drawerOpen)} />
      )}

      <Box
        sx={{
          display: "flex",
          marginTop: "64px",
        }}
        
      >
        <Routes>
          <Route path="/" element={ <Login /> } />
          <Route path="/verify" element={<Verification />} />
          <Route path="/home" element={<ProtectedRoute> <QRScanner /> </ProtectedRoute>} />
          <Route path="/qrJobScanner" element={<ProtectedRoute> <QRJobScanner /> </ProtectedRoute>} />            
          <Route path="/jobHistory" element={<ProtectedRoute> <JobsHistory /> </ProtectedRoute>} />
          <Route path="/jobHistoryAll" element={<ProtectedRoute> <JobsHistoryAll /> </ProtectedRoute>} />
          <Route path="/assignJob" element={<ProtectedRoute> <AssignJob /> </ProtectedRoute>} />
          <Route path="/todayAttendance" element={<ProtectedRoute> <TodayAttendance /> </ProtectedRoute>} />
          <Route path="/assignOT" element={<ProtectedRoute> <AssignOT /> </ProtectedRoute>} />       
          <Route path="/otDetails" element={<ProtectedRoute> <OTDetails /> </ProtectedRoute>} /> 
          <Route path="/holidayOT" element={<ProtectedRoute> <HolidayOT /> </ProtectedRoute>} /> 
          <Route path="/overTimeView" element={<ProtectedRoute> <OTTableViews /> </ProtectedRoute>} />  
          <Route path="/supervisorWiseOT" element={<ProtectedRoute> <SupervisorWiseOT /> </ProtectedRoute>} />  
          <Route path="/nonAllocatedEmp" element={<ProtectedRoute> <NonAllocatedEmp /> </ProtectedRoute>} />
          <Route path="/production" element={<ProtectedRoute> <Production/> </ProtectedRoute>} />
          <Route path="/employees" element={<ProtectedRoute> <Employees /> </ProtectedRoute>} />
          <Route path="/iwoRequest" element={<ProtectedRoute> <IWORequest /> </ProtectedRoute>} />
          <Route path="/events" element={<ProtectedRoute> <Events /> </ProtectedRoute>} />
          <Route path="/leaveApproval" element={<ProtectedRoute> <LeaveApproval /> </ProtectedRoute>} />
          <Route path="/insertFrames" element={<ProtectedRoute> <InsertFrames /> </ProtectedRoute>} />
          <Route path="/dailyRemark" element={<ProtectedRoute> <DailyRemark /> </ProtectedRoute>} />
          <Route path="/remarkHistory" element={<ProtectedRoute> <RemarkHistory /> </ProtectedRoute>} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Box>
    </>
  );
}

export default function Root() {
  return (
    <Router>
      <App />
    </Router>
  );
}